module.exports = __webpack_public_path__ + "static/video-placeholder-72098df6f482927892feb2a1b89bf29a.png";